// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3Gg12","info":"UpdateTermsInfo_info__2pNaD"};